<template lang="pug">
    page(:tabs="tabs" :delegated-loading="true")
        template(#title="") {{$t(`pages.system.${name}.title`)}}

        template(#search-template="")
            e-input-search(
                :value="$route.query.search"
                @input="changeQuery({query:{search:$event, filters: prepareQueryString(searchFilters)}})"
                class="search-input")
            v-layout(justify-center mb-2 class="filter-wrapper" ref="filter-wrapper")
                m-block-nav-search-extended(
                    ref="nav-search-extended"
                    attach=".filter-wrapper"
                    :z-index="1"
                    :position="filterPosition")

        template(#tabs="")

        template(#content="")
            component(:is="tab")
</template>

<script>
    import basePage from "@mixins/components/pages/base";
    import MTabObjects from "@modules/tabs/concrete/search/m-tab-objects";
    import MTabRiskAssessments from "@modules/tabs/concrete/search/m-tab-risk-assessments";
    import MTabUsers from "@modules/tabs/concrete/search/m-tab-users";
    import MBlockNavSearchExtended from "@modules/blocks/header/m-block-nav-search-extended";
    import {toolbarHeightAuth, toolbarHeightPublic} from "@utils/responsive";
    import {createNamespacedHelpers} from 'vuex';

    const {mapGetters, mapActions} = createNamespacedHelpers('search');

    let name = 'search';

    export default {
        name: name,
        mixins: [basePage],
        components: {MTabUsers, MTabRiskAssessments, MTabObjects, MBlockNavSearchExtended},
        props: {
            name: {
                type: String,
                default: name
            },
            meta: {
                type: Object,
                default: () => ({
                    title: `pages.system.${name}.meta.title`
                })
            }
        },
        data: () => {
            return {
                filterPosition: 0
            }
        },
        async mounted() {
            if(this.$route.query && this.$route.query.filters) {
                let queryFilters = this.parseQueryString(this.$route.query.filters);
                Object.keys(queryFilters).map(filterKey => {
                    if(Object.keys(this.searchFilters).includes(filterKey)) {
                        Object.keys(queryFilters[filterKey]).map(childKey => {
                            if (Object.keys(this.searchFilters[filterKey]).includes(childKey)) {
                                const payload = {
                                    filterGroup: filterKey,
                                    filterName: childKey,
                                    value: this.$lodash.isString(queryFilters[filterKey][childKey]) && this.isBoolean(queryFilters[filterKey][childKey])
                                        ? this.stringToBool(queryFilters[filterKey][childKey])
                                        : queryFilters[filterKey][childKey]
                                };
                                this.setOneFilter(payload);
                            }
                        })
                    }
                });
            }

            this.$nextTick(this.getFilterPosition)
        },
        watch: {
            searchFilters: {
                handler: function(val) {
                    this.changeQuery({query: {...this.$route.query, filters: this.prepareQueryString(val)}});
                },
                deep: true
            }
        },
        computed: {
            ...mapGetters({
                searchFilters: 'getFilters'
            }),
            tab() {
                if(this.$route.hash){
                    switch(this.$route.hash) {
                        case '#tab_objects': return 'm-tab-objects';
                        case '#tab_risk_assessments': return 'm-tab-risk-assessments';
                        case '#tab_users': return 'm-tab-users';
                    }
                }

                return 'm-tab-objects';
            },

            tabs() {
                return [
                    {
                        text: this.$t('pages.system.search.tabs.objects'),
                        name: 'tab_objects'
                    }, {
                        text: this.$t('pages.system.search.tabs.risk_assessments'),
                        name: 'tab_risk_assessments'
                    }, {
                        text: this.$t('pages.system.search.tabs.users'),
                        name: 'tab_users'
                    }
                ];
            }
        },
        methods:{
            ...mapActions(['setSearchString', 'setOneFilter']),
            changeQuery(object = {}) {
                this.$router.push({
                    query: Object.assign({}, this.$route.query, object.query),
                    hash: object.hash ? object.hash : this.$route.hash
                });
            },
            getFilterPosition() {
                const activatorElement = this.$refs['nav-search-extended'].$refs['activator'].$el;
                const activatorRect = activatorElement.getBoundingClientRect();
                if(this.authenticated) {
                    this.filterPosition = activatorRect.top + activatorRect.height - toolbarHeightAuth(this.$vuetify.breakpoint.name);
                }else{
                    this.filterPosition = activatorRect.top + activatorRect.height - toolbarHeightPublic(this.$vuetify.breakpoint.name);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
